// src/components/Sidebar/components/NewYearEventCard.jsx
import React from "react";
import { Box, Card, CardActionArea, Chip, Typography } from "@mui/material";

export default function NewYearEventCard({ onClick }) {
    return (
        <Box sx={{ px: 2, pb: 1.25 }}>
            <Card
                elevation={0}
                sx={{
                    borderRadius: 3,
                    overflow: "hidden",
                    border: "1px solid rgba(0,0,0,0.10)",
                    boxShadow: "0 8px 18px rgba(0,0,0,0.10)",
                }}
            >
                <CardActionArea
                    onClick={onClick}
                    sx={{
                        position: "relative",
                        p: 2,
                        color: "text.primary",
                        background: `
              linear-gradient(135deg,
                rgba(10, 15, 35, 0.92),
                rgba(255, 255, 255, 0.92) 55%,
                rgba(255, 215, 0, 0.16)
              )
            `,
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            pointerEvents: "none",
                            background: `
                radial-gradient(circle at 20% 20%, rgba(255,215,0,0.25), transparent 45%),
                radial-gradient(circle at 80% 35%, rgba(160,220,255,0.28), transparent 50%),
                radial-gradient(circle at 55% 90%, rgba(170,255,220,0.18), transparent 55%)
              `,
                            opacity: 0.95,
                        }}
                    />

                    <Box sx={{ position: "relative", display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography sx={{ fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.1 }}>
                            ✨ 신년 소원빌기
                        </Typography>
                        <Chip size="small" label="진행중" color="warning" sx={{ height: 20, fontWeight: 900 }} />
                    </Box>

                    <Typography
                        sx={{
                            position: "relative",
                            mt: 0.75,
                            fontSize: 12.5,
                            color: "text.secondary",
                            lineHeight: 1.3,
                        }}
                    >
                        산들에 소원빌기
                    </Typography>

                    <Box
                        sx={{
                            position: "relative",
                            mt: 1.2,
                            height: 2,
                            width: 64,
                            borderRadius: 999,
                            background: "linear-gradient(90deg, rgba(0,0,0,0.12), rgba(255,215,0,0.55))",
                            opacity: 0.8,
                        }}
                    />
                </CardActionArea>
            </Card>
        </Box>
    );
}
